/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type ListJobsStatus = typeof ListJobsStatus[keyof typeof ListJobsStatus] | null;


export const ListJobsStatus = {
  active: 'active',
  closed: 'closed',
  draft: 'draft',
} as const;
